<template>
	<el-menu mode="horizontal" :router="true" :default-active="activeLink">
		<router-link to="/dashboard">
			<logo size="mini" :show-title="false"/>
		</router-link>
		<el-menu-item class="hidden-sm-and-down" index="Dashboard" :route="{name:'Dashboard'}">Tableau de bord</el-menu-item>
		<el-menu-item v-if="user.hasProfile('SYSTEM') || user.hasProfile('USER')" class="hidden-sm-and-down" index="Checkups" :route="{name:'Checkups'}">Bilans</el-menu-item>
		<el-menu-item v-if="user.hasProfile('SYSTEM') || (user.hasProfile('USER') && isSdis)" class="hidden-sm-and-down" index="Daes" :route="{name:'Daes'}">DAE</el-menu-item>
		<el-menu-item v-if="user.hasProfile('SYSTEM') || user.hasProfile('SUPERADMIN') || user.hasProfile('ADMIN')" class="hidden-sm-and-down" index="Users" :route="{name:'Users'}">Utilisateurs</el-menu-item>
		<el-menu-item v-if="user.hasProfile('SYSTEM') || isSdis || isCrra" class="hidden-sm-and-down" index="Ephemeres" :route="{name:'Ephemeres'}">Ephémères</el-menu-item>
		<el-menu-item v-if="user.hasProfile('SYSTEM') || user.hasProfile('SUPERADMIN')" class="hidden-sm-and-down" index="Entities" :route="{name:'Entities'}">Entités</el-menu-item>
		<el-menu-item v-if="user.hasProfile('SYSTEM') || (user.hasProfile('SUPERADMIN') && isSdis) || (user.hasProfile('ADMIN') && isSdis)" class="hidden-sm-and-down" index="Medications" :route="{name:'Medications'}">Médicaments</el-menu-item>
		<el-menu-item v-if="user.hasProfile('SYSTEM') || (user.hasProfile('SUPERADMIN') && isSdis) || (user.hasProfile('ADMIN') && isSdis)" class="hidden-sm-and-down" index="History" :route="{name:'History'}">Historique</el-menu-item>
		<el-menu-item v-if="user.hasProfile('SYSTEM') || isSdis || isCrra" class="hidden-sm-and-down" index="Stats" :route="{name:'Stats'}">Statistiques</el-menu-item>
		<el-menu-item class="hidden-sm-and-down" index="APropos" :route="{name:'APropos'}" title="À propos">?</el-menu-item>
		<el-dropdown class="btn-user hidden-sm-and-down" trigger="click">
			<el-button type="primary" icon="fas fa-lg fa-user" plain></el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item icon="fas fa-user" disabled>{{user.name}}</el-dropdown-item>
				<el-dropdown-item v-for="profile in user.profiles" :key="profile.code" icon="fas fa-briefcase" disabled>{{profile.name}}</el-dropdown-item>
				<el-dropdown-item icon="fas fa-fw fa-user-edit" divided @click.native="openUserEdit">Votre compte</el-dropdown-item>
				<el-dropdown-item icon="fas fa-power-off" divided @click.native="logout">Déconnexion</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>

		<el-dropdown class="btn-menu hidden-md-and-up" trigger="click" @command="handleCommand">
			<el-button type="info" icon="fas fa-lg fa-bars" plain></el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item icon="fas fa-fw fa-user" disabled>{{user.name}}</el-dropdown-item>
				<el-dropdown-item v-for="profile in user.profiles" :key="profile.code" icon="fas fa-briefcase" disabled>{{profile.name}}</el-dropdown-item>
				<el-dropdown-item icon="fas fa-fw fa-user-edit" divided @click.native="openUserEdit">Votre compte</el-dropdown-item>
				<el-dropdown-item icon="fas fa-fw fa-home" divided command="Dashboard">Tableau de bord</el-dropdown-item>
				<el-dropdown-item v-if="user.hasProfile('SYSTEM') || user.hasProfile('USER')" icon="fas fa-fw fa-notes-medical" command="Checkups">Bilans</el-dropdown-item>
				<el-dropdown-item v-if="user.hasProfile('SYSTEM') || (user.hasProfile('USER') && isSdis)" icon="fas fa-fw fa-heartbeat" command="Daes">DAE</el-dropdown-item>
				<el-dropdown-item v-if="user.hasProfile('SYSTEM') || user.hasProfile('SUPERADMIN') || user.hasProfile('ADMIN')" icon="fas fa-fw fa-users" command="Users">Utilisateurs</el-dropdown-item>
				<el-dropdown-item v-if="user.hasProfile('SYSTEM') || isSdis || isCrra" icon="fas fa-fw fa-user-clock" command="Ephemeres">Ephemeres</el-dropdown-item>
				<el-dropdown-item v-if="user.hasProfile('SYSTEM') || user.hasProfile('SUPERADMIN')" icon="fas fa-fw fa-clinic-medical" command="Entities">Entités</el-dropdown-item>
				<el-dropdown-item v-if="user.hasProfile('SYSTEM') || (user.hasProfile('SUPERADMIN') && isSdis) || (user.hasProfile('ADMIN') && isSdis)" icon="fas fa-fw fa-prescription-bottle-alt" command="Medications">Médicaments</el-dropdown-item>
				<el-dropdown-item v-if="user.hasProfile('SYSTEM') || (user.hasProfile('SUPERADMIN') && isSdis) || (user.hasProfile('ADMIN') && isSdis)" icon="fas fa-fw fa-book-open" command="History">Historique</el-dropdown-item>
				<el-dropdown-item v-if="user.hasProfile('SYSTEM') || isSdis || isCrra" icon="fas fa-fw fa-chart-pie" command="Stats">Statistiques</el-dropdown-item>
				<el-dropdown-item icon="fas fa-question-circle" command="APropos">À propos</el-dropdown-item>
				<el-dropdown-item icon="fas fa-fw fa-power-off" divided @click.native="logout">Déconnexion</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</el-menu>
</template>

<script>
import Logo from '@/components/logo.component'
import store from '@/store'
import UserService from '@/services/user.service'
import EntityTypes from '@/constants/entity.types.const.js'

export default {
	name: 'Navbar',
	components: { Logo },
	computed: {
		activeLink: function() {
			return this.$route.meta.activeMenu
		},
		user: function() {
			return UserService.getCurrentUser()
		},
		isSdis: function () {
			return EntityTypes.SDIS === UserService.getCurrentUser().entityType
		},	
		isCrra: function () {
			return EntityTypes.CRRA === UserService.getCurrentUser().entityType
		},
		isTmp: function () {
			return EntityTypes.EPHEMERE === UserService.getCurrentUser().entityType
		}
	},
	methods: {
		logout() {
			store.dispatch('auth/logout');
		},
		openUserEdit() {
			this.$router.push('/users/' + this.user.id)
		},
		handleCommand(command) {
			this.$router.push({ name: command })
		}
	}
}
</script>

<style scoped>
.el-menu {
	height: 60px;
}

.logo {
	float: left;
	margin: 8px 20px 0 20px;
}

.btn-user, .btn-menu {
	float: right;
	margin-top: 10px;
	margin-right: 15px;
}
</style>
